import { api } from '@/core/api/';
import qs from 'qs';

const URL = 'api/provider';
const header = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export const saveNationalIdentifier = async (
  id,
  nationalIdentifier,
  medicalIdentifier
) => {
  return await api.patch(`${URL}/company/${id}/nationalIdentifier`, {
    nationalIdentifier,
    medicalIdentifier,
  });
};

export const saveMedicaidEligibility = async (id, payload) => {
  return await api.post(`${URL}/company/${id}/eligibility`, payload);
};

export const getProviderInitFilters = () => api.get(`${URL}/initfilters`);
export const getProviderApprovalInitFilters = () =>
  api.get(`${URL}/approval/initfilters`);

export const getProviderOptions = (payload) =>
  api.get(`${URL}/providersbyfilters`, {
    params: {
      ...payload,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'indices' }),
  });
export const getProviders = (payload) =>
  api.get(`${URL}/searchProvider`, {
    params: {
      ...payload,
    },
  });

export const getProviderBiddingRequests = (payload) =>
  api.get(`${URL}/biddingrequests`, {
    params: {
      ...payload,
    },
  });

export const getProviderTypes = () => api.get(`${URL}/companytypes`);

export const getCompanyBySsn = (ssn) => api.get(`${URL}/companybyssn/${ssn}`);

export const getCompanyById = (id) => api.get(`${URL}/companybyid/${id}`);

export const saveProvider = (payload) =>
  api.post(`${URL}/saveprovider`, payload);

export const editProviderInfo = (payload) =>
  api.put(`${URL}/editproviderinfo`, payload);

export const getContractRequiredDocuments = (companyId, academicYearId) =>
  api.get(`${URL}/contractrequireddocuments/${companyId}`, {
    params: {
      academicYearId,
    },
  });

export const getCompanyHeaderInfo = (companyId, academicYearId) =>
  api.get(`${URL}/companyheaderinfo/${companyId}`, {
    params: {
      academicYearId,
    },
  });

export const saveContractDocument = (params) =>
  api.post(`${URL}/savecontractdocument`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
export const replacecontractdocument = (params) =>
  api.put(`${URL}/replacecontractdocument`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
export const deleteContractDocument = (contractDocumentId) =>
  api.delete(`${URL}/deletecontractdocument/${contractDocumentId}`);

export const submitContractDocuments = (payload) =>
  api.post(`${URL}/submitcontractdocuments`, payload);

export const addProviderContact = (companyId, contact) =>
  api.post(`${URL}/addProviderContact/${companyId}`, contact);

export const editProviderContact = (contactId, companyId, contact) =>
  api.put(`${URL}/editProviderContact/${contactId}/${companyId}`, contact);

export const deleteProviderContact = (contactId) =>
  api.delete(`${URL}/deleteProviderContact/${contactId}`);

export const getProvidersByAcademicYear = (academicYearId, month) =>
  api.get(`${URL}/providersbyacademicyear/${academicYearId}?month=${month}`);

export const getSsn = (companyId, masked = false) =>
  api.get(`${URL}/ssn/${companyId}`, {
    params: {
      masked,
    },
  });

export const getBinnacles = (companyId) =>
  api.get(`${URL}/binnacles/${companyId}`);

export const saveBinnacleEntry = (entry) =>
  api.post(`${URL}/binnacle`, entry, header);

export const removeBinnacleEntry = (id) => api.delete(`${URL}/binnacle/${id}`);

export const getDefaultSearch = () => api.get(`${URL}/default/search`);
export const hasProporsalRequestSubmitted = (ssn) =>
  api.get(`${URL}/hasProporsalRequestSubmitted/${ssn}`);

export const updateDocumentExpirationDate = (
  contractDocumentId,
  documentExpirationDate
) =>
  api.put(`${URL}/updatedocumentexpirationdate/${contractDocumentId}`, null, {
    params: {
      documentExpirationDate,
    },
  });

export const updateDocumentAppointmentDate = (
  contractDocumentId,
  documentAppointmentDate
) =>
  api.put(`${URL}/updatedocumentappointmentdate/${contractDocumentId}`, null, {
    params: {
      documentAppointmentDate,
    },
  });

export const updateDocumentClassificationType = (
  contractDocumentId,
  classificationTypeId
) =>
  api.put(
    `${URL}/updatedocumentclassificationtype/${contractDocumentId}`,
    null,
    {
      params: {
        classificationTypeId,
      },
    }
  );

export const updateDocumentLicenseSpecialtyType = (
  contractDocumentId,
  licenseSpecialtyTypeId
) =>
  api.put(
    `${URL}/updatedocumentlicensespecialtytype/${contractDocumentId}`,
    null,
    {
      params: {
        licenseSpecialtyTypeId,
      },
    }
  );

export const getDocumentStatusHistory = (params) =>
  api.get(`${URL}/documentstatushistory`, { params });

export const updateDocumentExemptionFlag = (payload) =>
  api.put(`${URL}/updateexemptedflag`, payload);

export const getApprovalhistory = (params) =>
  api.get(`${URL}/approvalhistory`, { params });

export const deleteApprovalRequest = (academicYearId, companyId) =>
  api.delete(`${URL}/deleteapprovalrequest/${academicYearId}/${companyId}`);

export const isCompanyApproved = (academicYearId, companyId) =>
  api.get(`${URL}/isCompanyApproved/${academicYearId}/${companyId}`);

export const getProviderContacts = (providerId) =>
  api.get(`${URL}/contacts/${providerId}`);

export const syncUserInfo = (contact) =>
  api.post(`${URL}/contacts/sync`, contact);

export const getCompaniesWithNationalIdentifier = () =>
  api.get(`${URL}/companies/with-national-identifier`);
